module.exports = __webpack_public_path__ + "static/media/Goodnest_android_2_preview.ecd6a437.jpg";